import React from 'react';

interface ControlsProps {
  isStreaming: boolean;
  status: string;
  currentGeneration: number;
  maxGenerations: number;
  startStream: () => void;
  stopStream: () => void;
  resetGrid: () => void;
}

const Controls: React.FC<ControlsProps> = ({
  isStreaming,
  status,
  currentGeneration,
  maxGenerations,
  startStream,
  stopStream,
  resetGrid
}) => {
  return (
    <div className="controls">
      <div className="control-buttons">
        <button
          onClick={startStream}
          disabled={isStreaming}
          className="control-button start-button"
        >
          Start Stream
        </button>
        <button
          onClick={() => {
            console.log('🛑 Stop button clicked, isStreaming:', isStreaming);
            stopStream();
          }}
          disabled={!isStreaming}
          className="control-button stop-button"
        >
          Stop Stream
        </button>
        <button
          onClick={resetGrid}
          className="control-button reset-button"
        >
          Reset Grid
        </button>
      </div>
      <div className="status-info">
        <p>Generation: <strong>{currentGeneration}/{maxGenerations}</strong></p>
        <p>Status: <strong>{status}</strong></p>
      </div>
    </div>
  );
};

export default Controls;
